import { BottomControlsPanel } from "@rentablo/components";
import { InvestmentsAddButton } from "./InvestmentsAddButton";

export const InvestmentsPageMobilePanel = () => (
  <BottomControlsPanel actions={<InvestmentsAddButton />}>
    {null}
  </BottomControlsPanel>
);
